module.exports = __webpack_public_path__ + "static/media/ecom-nega.b1f8f953.svg";